<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('course_agreement_form')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('course_agreement_form')" :isFilter="false" />
            </template>
            <div class="row mb-5 align-items-center" v-if="errorMessage">
                <div class="col-12">
                    <div class="row border p-2 d-flex justify-content-center align-items-center">
                        <div class="d-flex flex-column align-items-center">
                            <i class="ri-information-line" style="font-size: 100px">
                            </i>
                            <p>
                            {{$t('api.'+errorMessage)}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-5 align-items-center" v-if="data != null">
                <div class="col-12">
                    <div class="row border mb-2 p-2">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('student_number')">
                                {{ data.student_number }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('name_surname')">
                                {{ data.name }} {{ data.surname }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('semester_name')">
                                {{ data.academic_year + ' /'+ this.getLocaleText(data, 'semester_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('faculty_name')">
                                {{ this.getLocaleText(data, 'faculty_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('program')">
                                {{ this.getLocaleText(data, 'program_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <b-form-group :label="$t('status')">
                                {{ this.getLocaleText(courseAgreement, 'status_name') }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" v-if="courseAgreement">
                            <b-form-group :label="$t('reason')">
                                {{ courseAgreement?.reason}}
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <b-alert :show="!!courseAgreementFormInfo" variant="info">
                <span v-html="courseAgreementFormInfo"></span>
            </b-alert>
            <div v-if="slots != null">
                <div v-if="courseAgreement!=null">
                    <div class="d-flex align-items-center justify-content-between">
                        <h6 class="mb-4">{{ $t('courses').toUpper() }}</h6>
                        <ProcessingButton class="d-flex justify-content-center mt-2 mb-2" v-if="['draft','change_request'].includes(courseAgreement?.status)"  :processing="loading"  :label="$t('add_NI_slot')" @click="addNISlots" />
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered w-100">
                            <tr>
                                <th>{{ $t('slot_type').toUpper() }}</th>
                                <th class="width-100">{{ $t('course_code').toUpper() }}</th>
                                <th>{{ $t('course_name').toUpper() + ' / ' + $t('elective_pool').toUpper() }}</th>
                                <th class="w-40">{{ $t('credit').toUpper() }}</th>
                                <th class="w-40">{{ $t('ects_credit').toUpper() }}</th>
                                <th class="w-40">{{ $t('semester').toUpper() }}</th>
                                <th class="w-40">{{ $t('grade').toUpper() }}</th>
                                <th class="w-40" >{{ $t('action').toUpper() }}</th>
                                <th style="width: 50%;text-align: center">{{ $t('selected_course').toUpper() }}</th>
                                <th v-if="!['draft'].includes(courseAgreement?.status)">{{ $t('status').toUpper() }}</th>
                                <th style="text-align: center" v-if="isCancelReason">{{ $t('cancel_reason').toUpper() }}</th>

                            </tr>

                            <tr v-for="slot in slots" v-bind:key="slot.id">
                                <td>{{ slot.slot_type?.name }}</td>
                                <td>{{ slot.course ? slot.course.code : '' }}</td>
                                <td>{{
                                        slot.course ? getLocaleText(slot.course, 'name') : (slot.pool ? getLocaleText(slot.pool, 'name') : '')}}
                                </td>
                                <td>{{ slot.credit }}</td>
                                <td>{{ slot.ects_credit }}</td>
                                <td>{{ slot.semester }}</td>

                                <td><span v-if="slot.last_course">{{ slot.last_course.letter_grade }}</span></td>
                                <td>
                                    <a v-if="isCheckedLetterGrade(slot)"
                                       role="button" class="ri-add-circle-line ri-2x" @click="addCourse(slot)"></a>
                                    <div v-else-if="isCheckDelete(slot)">
                                        <a role="button" class="ri-delete-bin-line ri-2x"  @click="deleteSelectedCourse(slot.selected_course.id)" style="color: red"> </a>
                                    </div>
                                </td>
                                <td v-if="slot.selected_course">
                                    <div class="d-flex flex-row align-items-center">
                                        <div class="mr-5">
                                            <strong>{{$t('course_code')+ ': '}}</strong> {{slot.selected_course?.code}}   <strong>{{$t('course_name') + ': '}}</strong> {{slot.selected_course?.name}}<strong> {{$t('type')+ ': '}}</strong>{{slot.selected_course?.type}}
                                        </div>
                                    </div>
                                </td>
                                <td v-else>
                                </td>
                                <td v-if="!['draft'].includes(courseAgreement.status)">
                                    {{getLocaleText(slot.selected_course, 'status_name')}}
                                </td>

                                <td class="text-wrap" v-if="isCancelReason">
                                    {{slot.selected_course?.reason}}
                                </td>

                            </tr>
                        </table>
                    </div>

                    <div  class="d-flex justify-content-center align-items-center mt-5" v-if="['draft','change_request'].includes(courseAgreement?.status)">
                        <b-button variant="primary" @click="sendApplication">{{
                                $t('send_application').toUpper()
                            }}
                        </b-button>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center flex-column">
                    <b-col cols="6" class="d-flex justify-content-center align-items-center">
                        <Signature
                            v-model="signature"
                            ref="signatureComponentRef"
                        />
                    </b-col>
                    <b-col cols="6" class="d-flex justify-content-center align-items-center mt-2" v-if="signature">
                        <b-button variant="primary" @click="startApplication">{{
                                $t('start_application').toUpper()
                            }}
                        </b-button>
                    </b-col>

                </div>
            </div>
            <CommonModal ref="courseModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" >
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('add_course') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <AddCourse v-if="formProcess==='add_course'" :isNISlot="isNISlot" :courseId="courseId" @successCreate="successCreate"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

import CommonModal from "@/components/elements/CommonModal";
import qs from "qs";
import ConstantService from "@/services/ConstantService";
import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";
import AddCourse from "@/modules/CourseAgreementForm/pages/AddCourse.vue"
import Signature from "@/components/elements/Signature.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
export default {
    components: {
        ProcessingButton,
        Signature,
        AddCourse,
        AppLayout,
        Header,
        HeaderMobile,
        CommonModal,

    },
    data() {
        return {
            isNISlot:false,
            courseAgreementFormInfo: null,
            data: null,
            slots: null,
            formProcess: null,
            selectedCourses: {},
            courseId: null,
            courseAgreement: null,
            errorMessage: null,
            signature:null,
            loading:false,
        }
    },
    metaInfo() {
        return {
            title: this.$t("course_agreement_form")
        }
    },
    created() {
        this.loadData()
        this.loadInfo()
    },
    computed:{
        isCancelReason(){
          return  ['change_request','declined','department_declined'].includes(this.courseAgreement.status)
        }

    },
    methods: {
        loadInfo() {
            const key = this.$i18n.locale === 'en' ? 'course_agreement_form_info_en' : 'course_agreement_form_info'
            const config = {
                params: { key },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.courseAgreementFormInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },
        loadData(){
            CourseAgreementFormServices.getCourse(this.$route.params.id??null)
                .then(response => {
                    this.data = response.data.data.student
                    this.slots = response.data.data.slots
                    this.courseAgreement=response.data.data.course_agreement
                }).catch(error => {
                    this.errorMessage=error.data.message
                    this.showErrors(error)
            });
        },
        addCourse(slot) {
            this.courseId=slot.id
            this.formProcess="add_course"
            this.$refs.courseModal.$refs.commonModal.show()
        },
        successCreate() {
            this.$refs.courseModal.$refs.commonModal.hide()
            this.formProcess=null
            this.loadData()
        },
        formClear(){
            this.formProcess=null
            this.isNISlot=false

        },
       async startApplication(){
           const isSignature=await this.$refs.signatureComponentRef.validate()
           if (!isSignature) return
           const formData =new FormData()
           formData.append('signature',this.signature)
            try {
               await CourseAgreementFormServices.startApplication(formData)
                this.$toast.success(this.$t("proccess_success"));
                this.loadData()
            }catch (error) {
                this.showErrors(error)
            }
        },
        isCheckedLetterGrade(slot) {
            if (!slot.selected_course && ['draft','change_request'].includes(this.courseAgreement.status))return true
        },
        isCheckDelete(slot){
            if (!['draft','change_request'].includes(this.courseAgreement.status))return false
            if (['waiting','draft','change_request','declined'].includes(slot.selected_course?.status) && slot.selected_course)return true
            if (slot.selected_course?.status==='waiting')return  false
            if (slot.selected_course?.status==='approved')return true

        },
        deleteSelectedCourse(id) {
            this.deleteModal(() => {
                CourseAgreementFormServices.deleteSelectedCourse(id)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.loadData();
                    })
                    .catch(error => {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    });
            });
        },
        async addNISlots(){
            this.isNISlot=true
            this.formProcess="add_course"
            this.$refs.courseModal.$refs.commonModal.show()
        },
       async sendApplication(){
             try {
                 const res =  await CourseAgreementFormServices.approvedApplication()
                 this.$toast.success(this.$t('api.' + res.data.message));
                 this.$router.push('/my-requests/5')
             }catch (error) {
                 this.showErrors(error)
             }
        },

    },
};
</script>
<style scoped>
.text-wrap {
    max-width: 200px;
    white-space: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    overflow-x: hidden;
    text-overflow: clip;
    padding: 8px;
}
</style>
